import {CommonModule} from "@angular/common";
import {Component, ElementRef, HostListener, OnInit, Renderer2} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {Router, RouterModule} from "@angular/router";
import {AuthService} from "../services/auth.service";
import {LoadingComponent} from "../../shared/loading/loading.component";
import {HeaderService} from "../services/header.service";
import {Subscription} from "rxjs";

interface Locale {
    code: string;
    label: string;
}

@Component({
    selector: "app-header",
    standalone: true,
    imports: [CommonModule, RouterModule, FormsModule, LoadingComponent],
    templateUrl: "./header.component.html",
    styleUrl: "./header.component.scss",
})
export class HeaderComponent implements OnInit {
    selectedLanguage: any = "en";
    public menuOpen: boolean = false;
    userAuthentcataed: boolean = false;
    selectedCountry: any;
    private headerSubscription: Subscription;
    // private headerSubscription: Subscription = new Subscription();


    localesList: Locale[] = [
        {code: "en", label: "English"},
        {code: "fr", label: "Francais"},
    ];

    constructor(private router: Router, private authService: AuthService, private headerService: HeaderService,
                private el: ElementRef, private renderer: Renderer2
    ) {
        this.headerSubscription = this.headerService.authenticationUser$.subscribe((status) => {
            this.userAuthentcataed = status; // Update authentication status in header
        });

        this.headerSubscription.add(
            this.headerService.selectedCountry$.subscribe((country: string | null) => {
                this.selectedCountry = country;
            })
        );
    }


    ngOnInit() {
        // Check if a language is already stored in localStorage
        if (typeof window !== "undefined") {
            const storedLanguage = localStorage.getItem("selectedLanguage");
            const country = localStorage.getItem("country");
            this.selectedCountry = country;
            if (storedLanguage) {
                this.selectedLanguage = storedLanguage;

            }
        }


    }

    @HostListener('document:click', ['$event'])
    handleClickOutside(event: MouseEvent) {
        // Check if click originated outside the dropdown element or its children
        const clickedInside = this.el.nativeElement.contains(event.target);
        if (this.menuOpen && !clickedInside) {
            this.menuOpen = false;
        }
    }


    openDropdown() {
        this.menuOpen = !this.menuOpen;
    }

    close() {
        this.menuOpen = !this.menuOpen;

    }

    navigateToHome() {
        this.menuOpen = false;
        if (this.router.url === "/planDetails") {
            this.router.navigate(["/home"], {replaceUrl: true});
        } else {
            window.location.reload();

        }
    }


    onClickSignUp() {
        this.authService.logout();
        this.menuOpen = !this.menuOpen;
        this.userAuthentcataed = false;
        this.router.navigate(["/login"]);
    }

    onClickManageSubscription() {
        if (this.selectedCountry == 'ca') {
            window.open(
                "https://www.lorex.ca/pages/subscriptions",
                "_blank"
            );
        } else if (this.selectedCountry == 'uk') {
            window.open(
                "https://www.lorextechnology.co.uk/pages/subscriptions",
                "_blank"
            );
        } else {
            window.open(
                "https://www.lorex.com/pages/subscriptions",
                "_blank"
            );
        }

        this.menuOpen = !this.menuOpen;

    }


    onClickMyAccount() {
        if (this.selectedCountry == 'ca') {
            window.open(
                "https://www.lorex.ca/account",
                "_blank"
            );
        } else if (this.selectedCountry == 'uk') {
            window.open(
                "https://www.lorextechnology.co.uk/account",
                "_blank"
            );
        } else {
            window.open(
                "https://www.lorex.com/account",
                "_blank"
            );

        }

        this.menuOpen = !this.menuOpen;
    }

    onClickMyDevices() {
        this.router.navigate(['devices'])
    }

    onClickMySubscriptions() {
        this.router.navigate(['subscriptions'])
    }


    selectLanguage(event: any) {
        this.selectedLanguage = event.target.value;
        localStorage.setItem("selectedLanguage", this.selectedLanguage);
        const languageExists = this.localesList.filter((lang: any) => {
            return window.location.href.includes(`/${lang.code}/`);
        });
        if (languageExists) {
            window.location.href = window.location.href.replace(
                `/${languageExists?.[0]?.code}/`,
                `/${this.selectedLanguage}/`
            );
        } else {
            window.location.href = `${window.location.origin}/${this.selectedLanguage}${window.location.pathname}`;
        }
    }

    // @HostListener('document:click', ['$event'])
    // onClickOutside(event: MouseEvent) {
    //   const targetElement = event.target as HTMLElement;
    //   if (!targetElement.closest('.dropdown')) {

    //     this.menuOpen =  false;
    //   }
    // }

    ngOnDestroy(): void {
        this.headerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
}
